<div class="hawlfraint">
  <div class="container-logo">
    <fa-icon class="eicon-hawlfraint" icon="copyright" size="xs"></fa-icon>

    <img [src]="nolLogo()" alt="Logo Cyngor Gwynedd" class="logo-footer" />

    <img [src]="nolLogoDatblygu()" alt="Logo Cyngor Gwynedd" class="logo-datblygu-footer" />
  </div>
</div>
